export default {
    'previous-deliverable' : 'When previous stage deliverable is complete',
    'previous-one-activity' : 'When at least one activity of previous stage is complete',
    // 'previous-all-activities' : 'When all activities of previous stage is complete',
    'always' : 'Always unlocked',
};
